<template>
  <div id="inner" class="top">
    <meta property="og:image" content="https://megahobbyexpo.jp/plus-2021jump/images/mgplus_img.jpg">
    <header class="clearfix">
      <h1><img src="@/assets/images/header_megahouse_item_infomation.png" alt="MEGAHOUSE ITEM INFOMATION"></h1>
      <nav>
        <ul>
          <!-- <li><a href="#item"><img src="@/assets/images/header_btn_item.png" alt="アイテム"></a></li>
          <li><a href="#livecommerce"><img src="@/assets/images/header_btn_livecommerce.png" alt="ライブコマース"></a></li> -->
          <li><a @click="scrollToAnchorPoint('newitem')" href="javascript:void(0)"><img src="@/assets/images/header_btn_item.png" alt="アイテム"></a></li>
          <li><a @click="scrollToAnchorPoint('livecommerce')" href="javascript:void(0)"><img src="@/assets/images/header_btn_livecommerce.png" alt="ライブコマース"></a></li>
          <li><a href="https://www.megahobby.jp/" target="_blank"><img src="@/assets/images/header_btn_megahobby.png" alt="メガホビ"></a></li>
        </ul>
      </nav>
    </header>

    <div id="content">
      <div id="main">
        <div class="bg"></div>
        <div class="bord">
          <div class="signbord">
            <img src="@/assets/images/main_signboard.png" alt="メガホビ+Plus">
          </div>
        </div>
        <div class="bottom">ジャンプ作品最新アイテム発表！</div>
      </div>

      <div id="contents_block">
        <div class="content" ref="newitem">
          <h2 class="content_ttl"><img src="@/assets/images/new_item_list_ttl.png" alt=""></h2>
          <div class="content_txt"><img src="@/assets/images/click_on_the_icon_txt.png" alt=""></div>

          <template v-for="lineup in lineup_list">
            <dl>
              <dt><h3>{{lineup.date}}</h3></dt>
              <dd>
                <template v-for="icon in lineup.icons">
                  <!-- <a v-if="icon.href" class="icon" :href="'?'+icon.param+'/#/'+icon.href"><img v-bind:src="icon.img"></a> -->
                  <router-link v-if="icon.href" class="icon" :to="icon.href"><img v-bind:src="icon.img"></router-link>
                  <div v-else class="icon"><img v-bind:src="icon.img"></div>
                </template>
              </dd>
            </dl>
          </template>

        </div>
        <div class="content" ref="livecommerce">
          <h2 class="content_ttl"><img src="@/assets/images/live_commerce_ttl.png" alt=""></h2>

          <ul class="clearfix">
            <li class="left">
              <!-- <img src="@/assets/images/coming_soon.png" alt=""> -->
              <img class="ytarea" src="@/assets/images/youtubearea.png" alt="">
              <iframe width="670" height="377" src="https://www.youtube.com/embed/YZ9yPwFELDU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </li>
            <li class="right">
              <h3>メガホビ ショッピングステーション！<br>【メガホビプラス ジャンプセレクション】</h3>
              <p>
                メガホビプラス開催に合わせてメガホビショッピングステーション第2回、配信です！<br>
                第2回目のゲストは #榎木淳弥 さん！<br>
                <br>
                今回はジャンプセレクション！ということで<br>
                「#呪術廻戦」の商品をご紹介＆抽選販売いたします！<br>
                あの魅力的なフィギュアのオススメポイントを紹介！お好きな方は要チェック☆<br>
                <br>
                【MC】佐藤拓也さん<br>
                【アシスタント】動画クリエーター サンダーさん<br>
                【第2回目ゲスト】榎木淳弥さん 
              </p>
            </li>
          </ul>
        </div>

        <div id="campaign">
          <!-- <img src="@/assets/images/content_campaign1.jpg" alt="メガホビ+Plus開催記念! メガトレショップ抽選販売祭実施! 2021.12.17～12/24 ラインナップは後日発表!"> -->
          <a href="https://p-bandai.jp/megatreshop/shoppingstation202112/list-da10-n0/" target="_blank">
            <img src="@/assets/images/content_campaign2.jpg" alt="メガホビ+Plus開催記念! メガトレショップ抽選販売祭実施中! 2021.12.17～12/24 詳細はこちら!">
          </a>
        </div>

      </div>
    </div>

    <footer>
      <div class="box">
        <div id="box_inner">
          <ul class="copy_megahobby clearfix">
            <li><a href="https://www.megahouse.co.jp/"><img src="@/assets/images/footer_logo_megahouse.png" alt="Megahouse"></a></li>
            <li>MegahouseCOPYRIGHT 2005-2021 MEGAHOUSE CORPORATION. ALL RIGHTS RESERVED.<br>
              ALL OTHER PRODUCTS ARE TRADEMARKS OR REGISTERED OF THEIR RESPECTIVE OWNERS.</li>
          </ul>
          <div id="footer_sns" class="clearfix">
            <div class="fb-like" data-href="https://megahobbyexpo.jp/plus-2021jump/" data-width="100" data-layout="button_count" data-action="like" data-size="small" data-show-faces="false" data-share="false"></div>
            <a href="https://twitter.com/share" class="twitter-share-button" data-text="#メガホビプラス" data-lang="ja">ツイート</a>
          </div>
          <copyright></copyright>
        </div>
      </div>
    </footer>
  </div>
</template>

<style lang="scss" src="@/views/common.scss"></style>
<style lang="scss" src="@/views/top.scss"></style>

<script>
import CopyRight from '@/components/CopyRight'

export default {
  name: 'top',
  components: {
    'copyright': CopyRight
  },
  data () {
    return {
      lineup_list: [
        {
          date: '12月18日10時公開',
          icons: [
            // {href: "", img: require("@/assets/images/items/schedule_01.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_03.jpg")},
            // // {href: "", img: require("@/assets/images/items/schedule_02.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_04.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_05.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_06.jpg")},

            // {href: "", img: require("@/assets/images/items/schedule_01.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_03.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_04.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_05.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_02_2.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_06_2.jpg")},

            // {href: "onepiece_01.html",  img: require("@/assets/images/items/onepiece_01.jpg")},
            // {href: "naruto_01.html",    img: require("@/assets/images/items/naruto_01.jpg")},
            // {href: "yugioh_01.html",    img: require("@/assets/images/items/yugioh_01.jpg")},
            // {href: "bleach.html",       img: require("@/assets/images/items/bleach.jpg")},
            // {href: "spyfamily_01.html", img: require("@/assets/images/items/spyfamily_01.jpg")},
            // {href: "haikyu.html",       img: require("@/assets/images/items/haikyu.jpg")},

            {href: "",  img: require("@/assets/images/items/onepiece_01.jpg")},
            {href: "",    img: require("@/assets/images/items/naruto_01.jpg")},
            {href: "",    img: require("@/assets/images/items/yugioh_01.jpg")},
            {href: "",       img: require("@/assets/images/items/bleach.jpg")},
            {href: "", img: require("@/assets/images/items/spyfamily_01.jpg")},
            {href: "",       img: require("@/assets/images/items/haikyu.jpg")},
            
          ]
        },
        {
          date: '12月19日10時公開',
          icons: [
            // {href: "", img: require("@/assets/images/items/schedule_07.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_08.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_09.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_10.jpg")},
            // {href: "", img: require("@/assets/images/items/schedule_11.jpg")},

            // {href: "onepiece_19a.html",  img: require("@/assets/images/items/onepiece_06.jpg")},
            // {href: "naruto_19a.html",    img: require("@/assets/images/items/naruto_02.jpg")},
            // {href: "kimetsu_19a.html",   img: require("@/assets/images/items/kimetsu_01.jpg")},
            // {href: "jujutsu_19a.html",   img: require("@/assets/images/items/jujutsu_01.jpg")},
            // {href: "digimon_19a.html",   img: require("@/assets/images/items/digimon_01.jpg")},

            {href: "",  img: require("@/assets/images/items/onepiece_06.jpg")},
            {href: "",    img: require("@/assets/images/items/naruto_02.jpg")},
            {href: "",   img: require("@/assets/images/items/kimetsu_01.jpg")},
            {href: "",   img: require("@/assets/images/items/jujutsu_01.jpg")},
            {href: "",   img: require("@/assets/images/items/digimon_01.jpg")},
          ]
        }
      ]
    }
  },
  mounted: function () {
    
  },
  methods: {
    // 
    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  }
}

document.oncontextmenu = function () {return false;}

!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+'://platform.twitter.com/widgets.js';fjs.parentNode.insertBefore(js,fjs);}}(document, 'script', 'twitter-wjs');
</script>




// WEBPACK FOOTER //
// src/views/top.vue